import React, { useState } from "react";
import styles from "./styles.module.css";
import global from "@components/global.module.css";
import { Formik } from "formik";
import cx from "classnames";
import addToMailchimp from "gatsby-plugin-mailchimp";

const SuccessScreen = ({ onClose }) => {
  return (
    <div className={cx(styles.screenRoot)}>
      <div className={styles.screenCover}>
        <p className={styles.successText}>
          Вы в клубе! Располагайтесь под лазерами, скоро начнется щелкотня и
          колотуха.
        </p>
      </div>
    </div>
  );
};

const Subscription = ({ mainPage }) => {
  const [isFormSent, setFormState] = useState(false);
  const [isLoading, setLoading] = useState(false);
  return (
    <>
      <div className={styles.root}>
        <div className={global.padding}>
          <div className={styles.formContainer}>
            <div className={styles.firstContainer}>
              <h3
                className={cx(styles.title, {
                  [styles.hidden]: isFormSent === true,
                })}
              >
                {mainPage.subscriptionText}
              </h3>
              {isFormSent && (
                <SuccessScreen
                  isScreenClose={isFormSent}
                  onClose={() => setFormState(false)}
                />
              )}

              <Formik
                initialValues={{
                  email: "",
                }}
                validate={(values) => {
                  const errors = {};

                  Object.keys(values).forEach((name) => {
                    if (values[name] === "") {
                      return (errors[name] = "");
                    }
                    if (
                      name === "email" &&
                      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                        values[name]
                      )
                    ) {
                      return (errors[name] = "Неверный email");
                    }
                  });
                  return errors;
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  setLoading(true);
                  addToMailchimp(values.email)
                    .then((_) => {
                      setLoading(false);
                      setSubmitting(false);
                      setFormState(true);
                      resetForm();
                    })
                    .catch((error) => {
                      console.error(error);
                      setSubmitting(false);
                      alert(
                        "Ошибка при отправке формы. Повторите попытку позднее"
                      );
                    });
                }}
              >
                {({
                  values,
                  errors,
                  handleChange,
                  handleSubmit,
                  isSubmitting,
                }) => (
                  <form
                    noValidate
                    autoComplete="off"
                    className={cx(styles.form, {
                      [styles.hidden]: isFormSent === true,
                    })}
                    onSubmit={handleSubmit}
                  >
                    <div className={styles.grid}>
                      <div className={styles.input}>
                        <input
                          className={cx({
                            [styles.errorInput]: errors.company,
                          })}
                          onChange={handleChange}
                          value={values.email}
                          type="email"
                          name="email"
                          placeholder="balaji@srinivasan.com"
                        />
                      </div>

                      {!isLoading && (
                        <button
                          className={styles.button}
                          type="submit"
                          disabled={isSubmitting}
                        >
                          Подписаться на рассылку
                        </button>
                      )}
                      {isLoading && (
                        <button
                          className={styles.button}
                          type="submit"
                          disabled={isSubmitting}
                        >
                          Фейсконтроль...
                        </button>
                      )}
                    </div>
                  </form>
                )}
              </Formik>
            </div>
            <div
              className={cx(styles.displayBlockOnDesktop, {
                [styles.hidden]: isFormSent === true,
              })}
            >
              <img
                width={150}
                src="https://images.ctfassets.net/67gkhzpoimdx/4MBSe6VINXR7JQ1noLqfPL/40932557a312f8c03c4b9e1c59c85142/form-image.png"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Subscription;
